import Vue from "vue";
// @ts-ignore
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

Vue.component("VSelect", vSelect);
